import { IconButton, useColorMode } from "@chakra-ui/react";
import { Sun, Moon } from "../icons";

// Botão sol/lua: alterna claro/escuro e o Chakra guarda a escolha (localStorage). Não há
// opção "Sistema" porque o gerenciador padrão grava o tema já resolvido; o sistema só
// decide no primeiro acesso.
export default function ColorModeToggle(props) {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === "dark";

  return (
    <IconButton
      aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"}
      title={isDark ? "Tema claro" : "Tema escuro"}
      icon={isDark ? <Sun size={18} /> : <Moon size={18} />}
      variant="ghost"
      onClick={toggleColorMode}
      {...props}
    />
  );
}
